import * as React from 'react'
import { styled } from 'next-yak'

import * as plume from '@ulule/owl-kit-components/next'
import type { YakComponentOf, PolymorphicComponent } from '@owl-nest/yak/extra-runtime'

const NotificationWrapper = styled(plume.styles.copy.S.semiBold)`
  align-items: center;
  background: ${plume.COLORS.PRIMARY_BLUE_500};
  border-radius: 2px;
  border: none;
  box-shadow: ${plume.EFFECTS.SHADOW_2};
  color: ${plume.COLORS.PRIMARY_GREY_000};
  cursor: pointer;
  display: flex;
  flex-direction: row;
  padding: 11px 15px;

  ${plume.styles.image.Avatar} {
    margin-right: 10px;
    background: ${plume.COLORS.PRIMARY_GREY_000};
  }

  @media not screen and ${plume.BREAKPOINTS.TABLET} {
    &::before {
      content: '';
      background-color: ${plume.COLORS.PRIMARY_BLUE_500};
      border-radius: 0 0 0 2px;
      clip-path: polygon(0% 0%, 100% 100%, 0% 100%);
      height: 10px;
      left: 27px;
      position: absolute;
      top: -5px;
      transform: rotate(135deg);
      width: 10px;
    }
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    &::before {
      content: '';
      background-color: ${plume.COLORS.PRIMARY_BLUE_500};
      border-radius: 0 0 0 2px;
      clip-path: polygon(0% 0%, 100% 100%, 0% 100%);
      height: 10px;
      left: -4px;
      position: absolute;
      transform: rotate(45deg);
      top: 17px;
      width: 10px;
    }
  }
` as YakComponentOf<PolymorphicComponent<'p', plume.styles.copy.CopyProps>>

type NotificationProps = {
  avatar?: string
  children: React.ReactNode
  className?: string
  onClick: () => void
}

function NotificationComponent({
  avatar,
  children,
  className,
  onClick,
}: NotificationProps): React.ReactElement<NotificationProps> {
  return (
    <NotificationWrapper onClick={onClick} className={className} as="button">
      {children}
    </NotificationWrapper>
  )
}

export const Notification = styled(NotificationComponent)<NotificationProps>``
